import React from 'react';
import { IconContext } from "react-icons";
import { FaRegCheckCircle } from 'react-icons/fa';
import queryString from 'query-string';

import AssetLink from './AssetLink';

require('../../css/components/AssetSlat.scss');

'use strict';

export default class AssetList extends React.Component {
    constructor(props) {
        super(props);
    }

    renderLanguages(languageUrls, languageNames, urlHash) {
        var languages = [];

        for (var l in languageUrls)
            languages.push(
                <AssetLink key={l} className="mr-2" url={languageUrls[l]} urlHash={urlHash} title={languageNames[l]} />
            );

        return languages;
    }

    render() {
        var asset = this.props.asset;

        var assignment = this.props.assignment;
        var assignmentComplete = assignment && assignment.displayAsComplete;

        var urlHash = this.props.urlHash || "";

        if (assignment) {
            urlHash = queryString.parse(urlHash);

            urlHash["assignmentId"] = this.props.assignmentId;

            if (!assignment.displayAsComplete && assignment.progress > 0 && assignment.progress < 1.0)
                urlHash["bookmark"] = Math.round(assignment.progress * 100) / 100;

            urlHash = queryString.stringify(urlHash);
        }

        var url = asset.url + (urlHash ? ("#" + urlHash) : "");

        var msgKey = "msg-" + this.props.parentKey;
        var copy = this.props.copy;

        return (
            <div className="assetSlat search-result">

                <div className="d-flex flex-row align-items-center assetSlat__title">
                    <div key="l">
                        <AssetLink asset={asset} urlHash={urlHash} />
                    </div>
                    <div key="a">
                        {
                            !assignment ?
                                null :
                                <div className="d-flex flex-column justify-content-center">
                                    {
                                        assignment.progress >= 1.0 ?
                                            <a className="btn collapsed" data-toggle="collapse" data-target={"#" + msgKey} aria-controls={msgKey} aria-expanded={false} title={copy.completedTooltip} >
                                                <IconContext.Provider value={{ className: "icon" }}>
                                                    <FaRegCheckCircle color="#009E0F" />
                                                </IconContext.Provider>
                                            </a> :
                                            null
                                    }
                                </div>
                        }
                </div>
            </div>
                {
                    !assignment ?
                        null :
                        assignmentComplete ?
                            <div id={msgKey} className="collapse">
                                <div className="msg" style={{ color: "#009E0F" }}>
                                    {copy.completedMessage}
                                </div>
                            </div> :
                            assignment.progress >= 1.0 ?
                                <div id={msgKey} className="collapse">
                                    <div className="msg" style={{ color: "#DB8008" }}>
                                        {copy.actionRequiredMessage}
                                    </div>
                                </div> :
                                null
                }
                <div className="d-flex flex-row" style={{ minHeight: "8em" }}>
                    <a className="assetSlat__imageHolder" href={url} style={{ backgroundImage: "url(" + asset.asset.thumbnailImagePath + ")" }} />

                    <div>
                        <div className="assetSlat__description">{asset.asset.description}</div>
                        <div className="search-result-detail"><span className="mr-1">{copy.mediaType}:</span>{asset.asset.type}</div>
                        <div className="search-result-detail">
                            <span className="mr-1">{copy.availableLanguages}:</span>
                            {this.renderLanguages(asset.languageUrls, this.props.languageNames, urlHash)}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}